/* ==========================================================================
   HOPE BASE ADVISORY LLC — MAIN JS ENTRY (WITH THEME SWITCHER)
   ========================================================================== */

import { initNavigation } from './navigation.js';
import { initHeroMatrix } from './hero-matrix.js';
import { initSectorTabs } from './sector-tabs.js';
import { initAfricaMap } from './africa-map.js';
import { initScrollAnimations } from './scroll-animations.js';
import { initProjectFilters } from './project-filters.js';
import { initConsultationModal } from './modal.js';
import { initThemeSwitcher } from './theme-switcher.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initThemeSwitcher();
  initHeroMatrix();
  initSectorTabs();
  initAfricaMap();
  initScrollAnimations();
  initProjectFilters();
  initConsultationModal();
});
